export default "__VITE_ASSET__DQsvlyTL__"